import { useContext } from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { apiGet, apiPost, apiPatch, apiDelete } from 'api'
import AuthContext from 'context/auth-context'

const getAdminDatumTags = async (token, municipalityId) => {
  const url = `admin/municipalities/${municipalityId}/datum_tags`
  return apiGet({ url, token })
}

const createAdminDatumTag = async (token, municipalityId, params) => {
  const url = `admin/municipalities/${municipalityId}/datum_tags`
  return apiPost({ url, token, objectName: 'datum_tag', params })
}

const updateAdminDatumTag = async (token, municipalityId, tagId, params) => {
  const url = `admin/municipalities/${municipalityId}/datum_tags/${tagId}`
  return apiPatch({ url, token, objectName: 'datum_tag', params })
}

const deleteAdminDatumTag = async (token, municipalityId, tagId) => {
  const url = `admin/municipalities/${municipalityId}/datum_tags/${tagId}`
  return apiDelete({ url, token })
}

export const useAdminDatumTags = ({ municipalityId, options } = {}) => {
  const token = useContext(AuthContext)
  return useQuery(
    ['admin-datum-tags', municipalityId],
    () => getAdminDatumTags(token, municipalityId),
    { enabled: !!municipalityId, ...options }
  )
}

export const useCreateAdminDatumTag = ({ municipalityId, options } = {}) => {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    (params) => createAdminDatumTag(token, municipalityId, params),
    {
      ...options,
      onSuccess: (data) => {
        queryClient.invalidateQueries(['admin-datum-tags', municipalityId])
        options?.onSuccess?.(data)
      }
    }
  )
}

export const useUpdateAdminDatumTag = ({ municipalityId, options } = {}) => {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    ({ tagId, params }) => updateAdminDatumTag(token, municipalityId, tagId, params),
    {
      ...options,
      onSuccess: (data) => {
        queryClient.invalidateQueries(['admin-datum-tags', municipalityId])
        options?.onSuccess?.(data)
      }
    }
  )
}

export const useDeleteAdminDatumTag = ({ municipalityId, options } = {}) => {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    (tagId) => deleteAdminDatumTag(token, municipalityId, tagId),
    {
      ...options,
      onSuccess: (data) => {
        queryClient.invalidateQueries(['admin-datum-tags', municipalityId])
        options?.onSuccess?.(data)
      }
    }
  )
}
